import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 14.4A6.4 6.4 0 1 0 8 1.6a6.4 6.4 0 0 0 0 12.8m3.507-7.834a.2.2 0 0 0 0-.283l-.566-.566a.2.2 0 0 0-.282 0L7.624 8.752 5.79 6.917a.2.2 0 0 0-.283 0l-.566.566a.2.2 0 0 0 0 .283l2.542 2.541a.2.2 0 0 0 .283 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }